import { ILoginForm } from "../../types/auth";
import { api } from "../api";

const LoginService = async (data: ILoginForm) => {

    const response = await api.post('auth/login', data);

    return response;

}

const MeService = async () => {

    const response = await api.get('auth/me');

    return response;

}

export {
    LoginService,
    MeService
}